import { useWorkspaceId } from "../../hooks/useWorkspaceId";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { useHttpTaxManagerAppHeaders } from "../utils/useHttpTaxManagerAppHeaders";
import { BASE_API_URL, HttpError } from "../utils/useTaxManagerAppQueryClient";

interface DeleteCustomFulfilmentRequest {
    levyId: string;
}

export function useDeleteCustomFulfilment() {
    const { t } = useTranslation();
    const workspaceId = useWorkspaceId();
    const headers = useHttpTaxManagerAppHeaders();
    const queryClient = useQueryClient();

    const mutation = useMutation<boolean, Error, DeleteCustomFulfilmentRequest>(
        {
            mutationFn: async (request) => {
                const response = await fetch(
                    `${BASE_API_URL}/tenants/${workspaceId}/fulfilments/custom/${request.levyId}`,
                    {
                        headers,
                        method: "DELETE",
                    },
                );

                if (!response.ok) {
                    throw new HttpError(response);
                }

                return true;
            },
            onSuccess: () => {
                queryClient.invalidateQueries({
                    queryKey: ["useGetFulfilments"],
                });
                queryClient.invalidateQueries({
                    queryKey: ["useGetLinkableFulfilments"],
                });
                queryClient.invalidateQueries({ queryKey: ["useGetKPIs"] });
            },
            meta: {
                errorMessage: t("errors.messages.deleteCustomFulfilment"),
            },
        },
    );

    return mutation;
}
